import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export interface ScoreEntry {
  id: string;
  name: string;
  score: number;
  level: number;
  created_at: string;
}

export const fetchTopScores = async (): Promise<ScoreEntry[]> => (await axios.get(`${API}/scores/top`, { params: { limit: 10 } })).data;

export const submitScore = async (name: string, score: number, level: number): Promise<ScoreEntry> =>
  (await axios.post(`${API}/scores`, { name, score, level })).data;

export interface DailyEntry {
  id: string;
  name: string;
  score: number;
  wave: number;
  seconds: number;
  platform: "desktop" | "mobile";
  day: string;
  rank_day?: number | null;
  rank_all?: number | null;
}

export const fetchDailyTop = async (platform: "desktop" | "mobile", scope: "day" | "all"): Promise<DailyEntry[]> =>
  (await axios.get(`${API}/daily/top`, { params: { platform, scope, limit: 10 } })).data;

export const submitDailyScore = async (name: string, score: number, wave: number, seconds: number, platform: "desktop" | "mobile"): Promise<DailyEntry> =>
  (await axios.post(`${API}/daily/scores`, { name, score, wave, seconds, platform })).data;

const NAME_KEY = "cave-critter-name";
export const loadName = () => localStorage.getItem(NAME_KEY) ?? "";
export const saveName = (n: string) => localStorage.setItem(NAME_KEY, n);

export interface PackMember {
  player_id: string;
  name: string;
  best_score: number;
  best_level: number;
  daily_day: string | null;
  daily_score: number;
  daily_wave: number;
}
export interface Pack { code: string; name: string; members: PackMember[] }

export const createPack = async (name: string, playerId: string, playerName: string): Promise<Pack> =>
  (await axios.post(`${API}/packs`, { name, player_id: playerId, player_name: playerName })).data;
export const joinPack = async (code: string, playerId: string, playerName: string): Promise<Pack> =>
  (await axios.post(`${API}/packs/${encodeURIComponent(code)}/join`, { player_id: playerId, player_name: playerName })).data;
export const leavePack = async (code: string, playerId: string): Promise<Pack> =>
  (await axios.post(`${API}/packs/${encodeURIComponent(code)}/leave`, { player_id: playerId })).data;
export const fetchPack = async (code: string): Promise<Pack> => (await axios.get(`${API}/packs/${encodeURIComponent(code)}`)).data;
export const reportPack = async (code: string, playerId: string, mode: "classic" | "daily", score: number, level: number): Promise<Pack> =>
  (await axios.post(`${API}/packs/${encodeURIComponent(code)}/report`, { player_id: playerId, mode, score, level })).data;
